export const SIZE_OPTIONS = {
  SMALL: 'small',
  MEDIUM: 'medium',
};

// order of positions or aligns is important, the first possible value will be applied
export const POSITIONS = {
  RIGHT: 'right',
  LEFT: 'left',
  TOP: 'top',
  BOTTOM: 'bottom',
};

export const ALIGNS = {
  CENTER: 'center',
  START: 'start',
  END: 'end',
};

export const POSITION_DIRECTIONS = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

export const TOOLTIP_SIZE = '240px';

export const TOOLTIP_PADDING = 7;

export const TOOLTIP_ARROW_SIZE = 7;

export const TOOLTIP_TOTAL_PADDING = TOOLTIP_PADDING + TOOLTIP_ARROW_SIZE;
